export default "__VITE_ASSET__JtVXGgQl__"